// @flow
import type { Dispatch } from "redux";
import { attempt, get, isEmpty } from "lodash";
import tvgConf from "@tvg/conf";
import calculateFeatureOverride from "@tvg/utils/featuresUtils";
import type { Feature, FeatureToggles } from "@tvg/conf/src/types";
import {
  failFeaturesRequest,
  successFeaturesRequest,
  failMessagesRequest,
  successMessagesRequest
} from "../../actions/capi";

const getFeaturesOverrides = () =>
  attempt(
    () => JSON.parse(window.localStorage.getItem("featureOverrides")),
    false
  );

const setFeaturesOverrides = (features: Feature) =>
  attempt(() =>
    window.localStorage.setItem("featureOverrides", JSON.stringify(features))
  );

export const applyFeaturesOverrides = (features: Array<Feature>) => {
  const featureToggles = {};
  let featureOverrides = getFeaturesOverrides() || {};
  const hasFeaturesOverrides = !!getFeaturesOverrides();

  features.forEach((toggle: Feature) => {
    let { enabled } = toggle;
    if (typeof window !== "undefined") {
      featureOverrides = calculateFeatureOverride(
        hasFeaturesOverrides,
        featureOverrides,
        toggle
      );
      if (get(featureOverrides, toggle.name)) {
        enabled = featureOverrides[toggle.name].enabled;
      }
    }

    featureToggles[toggle.name] = enabled;
  });

  if (typeof window !== "undefined" && !isEmpty(featureOverrides)) {
    // $FlowFixMe
    setFeaturesOverrides(featureOverrides);
  }

  return featureToggles;
};

export const getFeatures = (dispatch: Dispatch<*>) =>
  tvgConf()
    .getFeatures()
    .then((response: FeatureToggles | false) => {
      const featureToggles = applyFeaturesOverrides(
        get(response, "featureToggles", [])
      );
      dispatch(successFeaturesRequest(featureToggles));
    })
    .catch((err: Error) => dispatch(failFeaturesRequest(err)));

export const getMessages = (
  messageNamespaces: Array<string>,
  dispatch: Dispatch<*>
) => {
  tvgConf()
    .getMessages(messageNamespaces)
    .then((response) => dispatch(successMessagesRequest(response)))
    .catch((err: Error) => dispatch(failMessagesRequest(err)));
};
